import { KeyboardArrowDownRounded } from "@mui/icons-material";
import { Button, Card, CardContent, Menu, MenuItem, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { useParams } from "react-router";
import { ContainerGrid } from "src/components";
import { CreatePerformanceFeedbackModal, UserFeedbackTabs } from "./components";

interface IParams {
  userId: string;
}

const UserFeedbackPage = () => {
  const { userId } = useParams<keyof IParams>() as IParams;
  const [menuAnchor, setMenuAnchor] = useState<HTMLElement | null>(null);
  const [isPerformanceFeedbackModalVisible, setIsPerformanceFeedbackModalVisible] = useState<boolean>(false);

  return (
    <>
      <Stack spacing={{ xs: 0.75, md: 1 }}>
        <Card>
          <CardContent>
            <Stack direction="row" spacing={1} sx={{ justifyContent: "space-between", alignItems: "center" }}>
              <Stack spacing={0.5}>
                <Typography variant="h5">Feedback</Typography>
                <Typography>Create, send and receive reflections and feedback.</Typography>
              </Stack>
              <Button
                variant="contained"
                endIcon={<KeyboardArrowDownRounded />}
                onClick={(e) => setMenuAnchor(e.currentTarget)}
              >
                Add
              </Button>
            </Stack>
          </CardContent>
        </Card>

        <Menu anchorEl={menuAnchor} open={Boolean(menuAnchor)} onClose={() => setMenuAnchor(null)}>
          <MenuItem
            onClick={() => {
              setMenuAnchor(null);
              setIsPerformanceFeedbackModalVisible(true);
            }}
          >
            Performance Feedback
          </MenuItem>
        </Menu>

        <ContainerGrid container>
          <ContainerGrid size={{ sm: 12, md: 8 }} offset={{ md: 2 }}>
            <UserFeedbackTabs userId={userId} />
          </ContainerGrid>
        </ContainerGrid>
      </Stack>

      <CreatePerformanceFeedbackModal
        visible={isPerformanceFeedbackModalVisible}
        onSubmitted={() => setIsPerformanceFeedbackModalVisible(false)}
        onCancelled={() => setIsPerformanceFeedbackModalVisible(false)}
      />
    </>
  );
};

export { UserFeedbackPage };
